import Loading from "../../components/Loading";

/**
 * กล่องของโซนรูปฝั่งซ้ายตอนยังไม่มีรูป (loading / ไม่มีไฟล์) ใช้ร่วมกันทั้ง tab ea และ PK / CS (Photo)
 * ล็อกความสูงให้เท่ากับ InfoPlaceholder ฝั่งขวา เพื่อไม่ให้ layout หุบหรือกระโดด
 */
export const ImagePlaceholder = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div className="flex flex-row items-center justify-center w-full p-4 min-h-[24rem] lg:min-h-[32rem]">
    {children}
  </div>
);

export const NoImageBox = () => (
  <ImagePlaceholder>
    <div className="flex flex-row items-center justify-center w-full h-full rounded bg-slate-100">
      <span className="text-xl font-bold uppercase lg:text-4xl text-slate-500">
        No Image(s)
      </span>
    </div>
  </ImagePlaceholder>
);

// ใช้ Loading ไม่ใช่ Waiting เพราะ Waiting เป็น full-page loader (min-h-screen + absolute)
// เอามาวางในกล่องเล็กแล้วตัว spinner จะหลุดออกนอกกรอบ เห็นเป็นพื้นที่ว่างขาว ๆ
export const LoadingImage = () => (
  <ImagePlaceholder>
    <Loading />
  </ImagePlaceholder>
);
